<script>
  export let name;
  export let outline = false;
</script>

<div class:outline on:mousedown>{name}</div>

<style>
  div {
    font-size: 0.9rem;
    background-color: #eee;
    border-radius: 0.25rem;
    padding: 0.25rem;
    margin: 0.125rem;
  }

  .outline {
    color: rgb(69 84 119);
    font-weight: bold;
    background-color: rgb(219 224 236);
  }
</style>
